"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var SfilterAmenityAction;
(function (SfilterAmenityAction) {
    SfilterAmenityAction.ON_TOGGLE_AMENITY_SECTION = 'ON_TOGGLE_AMENITY_SECTION';
    SfilterAmenityAction.TOGGLE_AMENITY_SECTION = 'TOGGLE_AMENITY_SECTION';
    SfilterAmenityAction.TOGGLE_AMENITY_OPTION = 'TOGGLE_AMENITY_OPTION';
    SfilterAmenityAction.CHANGE_AMENITY_OPTION = 'CHANGE_AMENITY_OPTION';
    SfilterAmenityAction.toggleAmenitySection = typesafe_actions_1.createAction(SfilterAmenityAction.TOGGLE_AMENITY_SECTION, function (resolve) { return function (state) { return resolve(state); }; });
    SfilterAmenityAction.onToggleAmenitySection = typesafe_actions_1.createAction(SfilterAmenityAction.ON_TOGGLE_AMENITY_SECTION, function (resolve) { return function () { return resolve(); }; });
    SfilterAmenityAction.onToggleAmenityOption = typesafe_actions_1.createAction(SfilterAmenityAction.TOGGLE_AMENITY_OPTION, function (resolve) { return function (key) { return resolve(key); }; });
    SfilterAmenityAction.changeAmenityOption = typesafe_actions_1.createAction(SfilterAmenityAction.CHANGE_AMENITY_OPTION, function (resolve) {
        return function (key, state) { return resolve({ key: key, state: state }); };
    });
})(SfilterAmenityAction || (SfilterAmenityAction = {}));
exports.default = SfilterAmenityAction;
